/**
 * Négociation sur une annonce « Je cherche » (recherche) : compare la fiche de vente
 * aux critères indiqués par l’acheteur. Seuls les champs listés dans
 * `recherche_criteres_requis` (lorsqu’il est défini) sont vérifiés, ou sinon — compat
 * ancien comportement — tous les champs non vides de l’annonce d’achat.
 */

import { departmentValuesMatch, isDepartementCriterionKey } from "@/lib/departementDisplay";

function normalizeCustomFields(v) {
  if (!v || typeof v !== "object" || Array.isArray(v)) return {};
  return { ...v };
}

/**
 * @param {{ custom_fields?: object, recherche_criteres_requis?: string[] | null } | null | undefined} annonceRecherche
 * @param {{ custom_fields?: object } | null | undefined} offreVente
 * @returns {boolean}
 */
export function offreVenteCorrespondARecherche(annonceRecherche, offreVente) {
  const a = normalizeCustomFields(annonceRecherche?.custom_fields);
  const b = normalizeCustomFields(offreVente?.custom_fields);
  const criteresRequis = annonceRecherche?.recherche_criteres_requis;
  const keysToCheck =
    Array.isArray(criteresRequis) && criteresRequis.length > 0
      ? criteresRequis
      : Object.keys(a).filter((k) => a[k] != null && a[k] !== "");

  for (const k of keysToCheck) {
    const v = a[k];
    if (v == null || v === "") continue;
    if (isDepartementCriterionKey(k)) {
      if (!departmentValuesMatch(v, b[k])) return false;
      continue;
    }
    if (String(b[k] ?? "") !== String(v)) {
      return false;
    }
  }
  return true;
}
